var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsersmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91 5.48h-.78V3.39c0-.57-.47-1.04-1.04-1.04H6v-.78C6 .83 5.43.27 4.7.27c-.73 0-1.3.56-1.3 1.3v.78H1.3c-.57 0-1.04.47-1.04 1.04v1.98h.78c.79 0 1.41.63 1.41 1.41 0 .79-.62 1.41-1.4 1.41H.25v1.98c0 .58.47 1.05 1.04 1.05H3.3v-.79a1.4 1.4 0 1 1 2.82 0v.79h1.98c.57 0 1.04-.47 1.04-1.05V8.1h.78c.73 0 1.3-.58 1.3-1.3 0-.74-.57-1.31-1.3-1.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsersmall);
export default __webpack_public_path__ + "static/media/browser.small.576080a45b98555879dacb07f3117720.svg";
export { ForwardRef as ReactComponent };